// extracted by mini-css-extract-plugin
module.exports = {"carousel-provider":"_89b4965636--carousel-provider--VpjYd","carousel":"_89b4965636--carousel--ewH22","slider":"_89b4965636--slider--ZFtYy","button":"_89b4965636--button--upLkb"};